import React from 'react';
import ProductGrid from '../../components/client/ProductGrid';

const Products = () => {
  return <ProductGrid />;
};

export default Products;
